import { opal } from './opal.js';
export const ALL_THEMES = {
    opal,
};
//# sourceMappingURL=index.js.map